import { Modal, Form, IFormContext } from 'rewire-ui';
import {
  DeepPartial,
  IUser,
  PhoneNumberInput,
  UserProfileInput
}                                    from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import DataQueries                   from '../graphql/Queries';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { notifications }             from '../ui/Notifications';
import { dataUrlToFile }             from '../utility/DataConverters';

export class UserProfileDialogModel extends Modal {
  form:    Form;
  userId?: string;

  constructor() {
    super();
    this.form = Form.create((form: IFormContext) => ({
      name:         form.string().label('Name').placeholder('enter your name').autoFocus(),
      phone:        form.phone().label('Phone').placeholder('enter your phone number'),
      email:        form.static().label('Email'),
      organization: form.static().label('Organization'),
      location:     form.static().label('Location'),
      role:         form.static().label('Role'),
      avatar:       form.avatar({width: 1024, height: 768, avatarDiameter: 150, cropRadius: 75}).label('Add Photo'),
    }), {}, {updateOnChange: true, disableErrors: true});

    this.action('cancel', { variant: 'text' })
        .action('save', this.submit, {type: 'submit', disabled: () => !this.form.hasChanges}); 
  }

  reset() {
    this.form.reset();
    this.userId = undefined;
  }

  load = async () => {
    const userData = await this.getUserData();
    if (!userData) {
      this.reset();
      return;
    }

    this.userId     = userData.id!;
    this.form.value = {
      name:         userData.name,
      phone:        userData.phone?.home,
      email:        userData.email,
      organization: userData.organization!.name,
      location:     userData.location!.name,
      role:         userData.userSecurity?.role!.name,
      avatar:       userData.avatar,
    };

    this.open();
  };

  get userInitials() {
    return mainPageModel.userInitials;
  }

  getUserData = async (): Promise<DeepPartial<IUser>> => {
    const returnSchema = `
      id
      name
      phone {
        home
        mobile
        work
        fax
        workFax
      }
      email
      organization {
        name
      }
      location {
        name
      }
      userSecurity {
        role {
          name
        }
      }
      avatar
    `;

    return await DataQueries.getSessionInfo(returnSchema);
  };

  private save = async (): Promise<boolean> => {
    const avatar = this.form.field.avatar.value;
    const updateUserData: UserProfileInput = {
      name: this.form.field.name.value,
      phone: {home: this.form.field.phone.value && String(this.form.field.phone.value)} as PhoneNumberInput,
      avatar: avatar && (!avatar.match(/^data:image/) ? avatar : dataUrlToFile(this.form.field.avatar.value, 'avatar.png')),
    };

    const result = await DataMutations.updateUserProfile(updateUserData);
    if (result) {
      notifications.success('Profile Updated');
      mainPageModel.updateUser();
      return true;
    }

    notifications.error('Profile Update Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const userProfileDialogModel = new UserProfileDialogModel();
export default userProfileDialogModel;
